<template>
  <div class="entry">
    <img src="../../static/images/userBg.jpg" class="entry-bg"/>
    <div class="card">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'userEntry'
}
</script>

<style scoped>
.entry {
  font-size: 0;
}
.entry-bg {
  width: 100%;
}
.card {
  z-index: 99;
  width: 800px;
  position: fixed;
  top: 50%;
  left: 50%;
  margin-left: -400px;
  margin-top: -315px;
}
@media (max-width: 1199px) {
  .card {
    width: 640px;
    margin-left: -320px;
    margin-top: -250px;
  }
}
@media screen and (max-width: 801px){
  .card {
    position: relative;
    width: 100%;
    top: 0;
    left: 0; 
    margin: 0;
  }
}
</style> 




// WEBPACK FOOTER //
// src/components/userEntry.vue